// src/season-cluster/infrastructure/ui-services/seasonUiService.ts

export const $SEASON_ROUTE_QUERY_NAME = "split";

export const $SEASONS_WITHOUT_DATA: number[] = [8, 1, 2];

//season ids for world cup events, nations & clubs
export const $SEASONS_WORLD_CUP: number[] = [13, 14, 28, 37];
